import { createApp } from 'vue'
import { createPinia } from 'pinia';

import App from './App.vue'
import router from './router'
import i18n from './i18n';
// import $ from 'jquery'

import adminBox from './components/adminBox.vue'
import MainHeader from './components/newHeader.vue'
import MainFooter from './components/footer.vue'
import SideBar from './components/sidebar.vue'
import DSideBar from './components/d_sidebar.vue'
import Modal from './components/modal.vue'
import Chat from './components/chatbox.vue'
import GroupChat from './components/groupchat.vue'
import Video from './components/video.vue'
import Loading from './components/loading.vue'
import Pending from './components/pending.vue'
import notesBox from './components/notesBox.vue'
import videoBox from './components/videoBox.vue'
import VideoPlayer from './components/VideoPlayer.vue'
import historyBox from './components/historyBox.vue'
import VotingResult from './components/votingResult.vue'
import RecordingTool from './components/recordingTool.vue';

import SubHeader from './components/header_inSub.vue'

import DashboardMenu from './components/Dashboard/d_menu.vue'
import TeacherMenu from './components/Dashboard/t_menu.vue'
import DashboardModal from './components/Dashboard/d_modal.vue'

import cmsSidebar from './cms/SideBar.vue'
import FacebookShareButton from './components/shareFacebook.vue';
import TwitterShareButton from './components/shareTwitter.vue';
// script setup
import BaseModal from './components/baseModal.vue'


const app = createApp(App)
app.component('adminBox', adminBox)
app.component('MainHeader', MainHeader)
app.component('SubHeader', SubHeader)
app.component('MainFooter', MainFooter)
app.component('Loading', Loading)
app.component('Pending', Pending)
app.component('notesBox', notesBox)
app.component('videoBox', videoBox)
app.component('historyBox', historyBox)
app.component('VotingResult', VotingResult)
app.component('SideBar', SideBar)
app.component('DSideBar', DSideBar)
app.component('Modal', Modal)
app.component('BaseModal', BaseModal)
app.component('Video', Video)
app.component('VideoPlayer', VideoPlayer)
app.component('Chat', Chat)
app.component('GroupChat', GroupChat)
app.component('TwitterShareButton', TwitterShareButton)
app.component('FacebookShareButton', FacebookShareButton)

app.component('cmsSidebar', cmsSidebar)
app.component('d_menu', DashboardMenu)
app.component('t_menu', TeacherMenu)
app.component('d_modal', DashboardModal)
app.component('RecordingTool', RecordingTool)
app.use(createPinia())
app.use(router)
app.use(i18n);
app.mount('#app')

